export default "__VITE_ASSET__CxoLpwFI__"